/* tslint:disable */
/* eslint-disable */
export enum ConfigSettingsType {
  GLOBAL_CONFIG = 0,
  PRACTICE_CONFIG = 1
}
